import { render } from "./Risks.vue?vue&type=template&id=68bc0c44&scoped=true"
import script from "./Risks.vue?vue&type=script&lang=js"
export * from "./Risks.vue?vue&type=script&lang=js"

import "./Risks.vue?vue&type=style&index=0&id=68bc0c44&lang=scss"
import "./Risks.vue?vue&type=style&index=1&id=68bc0c44&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/avalia-assess/avalia-playbook-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68bc0c44"]])

export default __exports__